import { render, staticRenderFns } from "./bests.component.vue?vue&type=template&id=3836b3a1&scoped=true"
import script from "./bests.component.vue?vue&type=script&lang=js"
export * from "./bests.component.vue?vue&type=script&lang=js"
import style0 from "./bests.component.vue?vue&type=style&index=0&id=3836b3a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3836b3a1",
  null
  
)

export default component.exports